import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { convertDataFromServerToRedux } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/tools';

import { msg } from 'src/tools/message';

import { EnumCollapseId } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/common';

import {
  getContentHomepage,
  postContentHomepage,
} from '@/src/request/salesChannel/content';
import {
  onCollapseOpen as _onCollapseOpen,
  hasError,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getEntityUuid as _getEntityUuid,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getH1TagUuid as _getH1TagUuid,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';
//import _ from 'lodash';
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  moduleContentDynamicOnChange as _moduleContentDynamicOnChange,
  moduleContentOnChange as _moduleContentOnChange,
  moduleContentStaticOnChange as _moduleContentStaticOnChange,
  onModuleTypeChange as _onModuleTypeChange,
  handleOnContentListResponsiveLayerEditSubmit,
  handleOnModuleDuplicate,
  handleOnModuleReset,
  visibleModuleCheck,
} from 'src/constrains/DraggableModules/reduxFunctions';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
// import {
//   currentSelectedLanguage,
//   currentPrimaryLanguage,
// } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';

export const fetchContentHomepage = createAsyncThunk(
  'fetchSalesChannelContentHomepage',
  async (
    data: any,
    //thunkAPI,
  ) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();

    const response = await getContentHomepage(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitContentHomepage = createAsyncThunk(
  'submitSalesChannelContentHomepage',
  async ({ body, params }: any) => {
    const response = await postContentHomepage(body, params || {});
    const isPrimary = isCurrentPrimary();
    return { response, isPrimary };
  },
);

const defaultStatus = {
  isDataValid: false,
  hasModified: false,
};

const defaultState = {
  moduleContentOrder: [], //{两个不变参数moduleType,draggableId}
  moduleContentStaticConfig: {},
  moduleContentDynamicConfig: {}, //理想情况下，这里还可以再拆，因为这里也是array，看接下来的需求吧, 若果更复杂了就拆， 扁平化，最好不出现index
  collapseOpen: {
    [EnumCollapseId.iconStyle]: false,
    [EnumCollapseId.seoSetting]: false,
    [EnumCollapseId.floatingBar]: false,
  },
  collapseErrorMsgDisplay: {
    [EnumCollapseId.iconStyle]: { hasError: false, display: false },
    [EnumCollapseId.seoSetting]: { hasError: false, display: false },
    [EnumCollapseId.floatingBar]: { hasError: false, display: false },
  },
  iconStyle: {
    colour: '#000000',
  },
  seoSetting: { title: '', description: '', favicon: null },
  contentUuid: null,
  salesChannelContent: {},
  miniProgramShare: {},
  salesChannelName: '',
  loaded: false,
  uuid: null,
  floatingBar: {
    enable: true,
    backgroundColor: '#FFFFFF',
    iconColor: '#000000',
    expandable: true,
    expandableIcon: null,
    buttons: [],
  },
  ...defaultStatus,
  lastSubmitStamp: JSON.stringify(new Date()),
};

function assData(state, data = {}) {
  Object.keys(data).forEach((i) => {
    state[i] = data[i];
  });
}

const salesChannelContentHomepage = createSlice({
  name: 'salesChannelContentHomepage',
  initialState: defaultState,
  //function assignState(){}
  reducers: {
    onLoadedChange(state, action) {
      state.loaded = action.payload;
    },
    onModuleReset(state, action) {
      handleOnModuleReset(state, action);
    },
    onDuplicate(state, action) {
      handleOnModuleDuplicate(state, action);
    },
    moduleContentOnChange(state, action) {
      _moduleContentOnChange(state, action);
    },
    onModuleTypeChange(state, action) {
      _onModuleTypeChange(state, action.payload);
    },
    moduleContentStaticOnChange(state, action) {
      _moduleContentStaticOnChange(state, action);
    },
    moduleContentDynamicOnChange(state, action) {
      // console.log(action.payload);
      _moduleContentDynamicOnChange(state, action);
    },
    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },

    onErrorChange(state, action) {
      const { id, status } = action.payload;

      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    onChanged(state) {
      state.hasModified = true;
    },
    onFloatingActionsBarChange(state, action) {
      state.hasModified = true;
      state.floatingBar = {
        ...state.floatingBar,
        ...action.payload,
      };
    },

    onIconStyleChange(state, action) {
      state.hasModified = true;
      state.iconStyle = { ...state.iconStyle, ...action.payload };
    },

    onSeoSettingChange(state, action) {
      state.hasModified = true;
      state.seoSetting = { ...state.seoSetting, ...action.payload };
    },
    onMiniProgramShareChange(state, action) {
      state.hasModified = true;
      state.miniProgramShare = {
        ...state.miniProgramShare,
        ...action.payload,
      };
    },
    onContentListResponsiveLayerEditSubmit(state, action) {
      handleOnContentListResponsiveLayerEditSubmit(state, action);
    },
    validation(state) {
      state.lastSubmitStamp = JSON.stringify(new Date());
      // console.log(
      //   'state.collapseErrorMsgDisplay',
      //   JSON.stringify(state.collapseErrorMsgDisplay),
      // );
      hasError(state, state.collapseErrorMsgDisplay || {});
      visibleModuleCheck(state);
    },
    resetData(state) {
      assData(state, defaultState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContentHomepage.pending, (state, action) => {
      state.loaded = false;
    });
    builder.addCase(fetchContentHomepage.fulfilled, (state, action) => {
      const { response, isPrimary, isClone } = action.payload;

      const _data = convertDataFromServerToRedux(response, isPrimary) || {};

      assData(state, _data);
      if (isClone) state.hasModified = true;
    });

    builder.addCase(fetchContentHomepage.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(submitContentHomepage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitContentHomepage.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(submitContentHomepage.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));

      assData(state, { ..._data });
    });
  },
});

export const getContent = (draggableId) => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent.homepage.moduleContentStaticConfig[draggableId],
    (state: any) =>
      state.salesChannelContent.homepage.moduleContentDynamicConfig[
        draggableId
      ],

    (staticData, dynamicData) => {
      //console.log('staticData, dynamicData', staticData, dynamicData);
      return {
        staticData: staticData || {},
        dynamicData: dynamicData || [],
      };
    },
  );
};

export const getAllContent = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent.homepage.moduleContentStaticConfig,
    (state: any) =>
      state.salesChannelContent.homepage.moduleContentDynamicConfig,
    (state: any) => state.salesChannelContent.homepage.iconStyle,

    (staticData, dynamicData, iconStyle) => {
      return {
        staticData: staticData || {},
        dynamicData: dynamicData || [],
        iconStyle,
      };
    },
  );
};

export const getLoaded = () => {
  return _getLoaded(EnumReducers.homepage);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.homepage);
};

export const getState = () => {
  return _getState(EnumReducers.homepage);
};

export const getGeneralMiniProgramShare = () => {
  return _getGeneralMiniProgramShare(EnumReducers.homepage);
};

export const getGeneralMiniProgramPageInfo = () => {
  return _getGeneralMiniProgramPageInfo(EnumReducers.homepage);
};

export const getOrder = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.homepage.moduleContentOrder,
    (order) => {
      return order;
    },
  );
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.homepage);
};

export const getCollapseStatus = (id) => {
  return createSelector(
    (state: any) => state.salesChannelContent.homepage.collapseOpen[id],
    (status) => {
      return status;
    },
  );
};

export const getOpeningCollapse = (order) => {
  return createSelector(
    (state: any) => {
      const _r = [];
      for (const item of order) {
        const { draggableId: id } = item;
        if (state.salesChannelContent.homepage.collapseOpen[id]) {
          _r.push(id);
        }
      }
      return _r;
    },
    (status) => {
      return status;
    },
  );
};

export const getFloatingActionsBar = () => {
  return createSelector(
    (state: any) => {
      return state.salesChannelContent.homepage.floatingBar;
    },
    (floatingBar) => {
      return floatingBar;
    },
  );
};

export const getVisibleCollapse = (order) => {
  return createSelector(
    (state: any) => {
      const _r = [];
      for (const item of order) {
        const { draggableId: id } = item;
        if (
          state.salesChannelContent.homepage.moduleContentStaticConfig[id]
            .visible
        ) {
          _r.push(id);
        }
      }
      return _r;
    },
    (status) => {
      return status;
    },
  );
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.homepage, id);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.homepage);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.homepage);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.homepage, id);
};

export const getH1TagUuid = () => {
  return _getH1TagUuid(EnumReducers.homepage);
};

export const getEntityUuid = () => {
  return _getEntityUuid(EnumReducers.homepage);
};

export { EnumCollapseId };

export const {
  moduleContentOnChange,
  moduleContentStaticOnChange,
  moduleContentDynamicOnChange,
  onIconStyleChange,
  onSeoSettingChange,
  onCollapseOpen,
  validation,
  onErrorChange,
  onFloatingActionsBarChange,
  resetData,
  onModuleTypeChange,
  onMiniProgramShareChange,
  onContentListResponsiveLayerEditSubmit,
  onDuplicate,
  onModuleReset,
  onChanged,
  onLoadedChange,
} = salesChannelContentHomepage.actions;

export default salesChannelContentHomepage.reducer;
